export const map_minZoomLevel = 15;
export const map_maxZoomLevel = 18;
export const map_defaultZoomLevel = 16;
export const map_defaultZoomLevel_forMobile = 15;
export const coord_UmEmapCenter = [22.1288, 113.543905];
export const coord_UmEmapTopLeft = [22.135925, 113.539801];
export const coord_UmEmapTopRight = [22.136373, 113.547724];
export const coord_UmEmapBottomLeft = [22.123333, 113.540686];
export const coord_UmEmapBottomRight = [22.120053, 113.546823];
export const coord_maxBoundsSouthWest = [22.0188, 113.403905];
export const coord_maxBoundsNorthEast = [22.2288, 113.633905];
//export const coord_defaultSrc = [22.1286687781011, 113.54569928421]; // CTB
export const coord_defaultSrc = [22.1300296, 113.5454218]; // LIB
//export const coord_defaultDst = [22.1300296, 113.5444218]; 
export const coord_defaultDst = [22.1286687781011, 113.54569928421]; // CTB
export const coord_defaultLocateMe = [22.1300296, 113.5454218]; // LIB Front
export const polygon_UmEmap = [coord_UmEmapTopLeft, coord_UmEmapTopRight, coord_UmEmapBottomRight, coord_UmEmapBottomLeft];

